import { render, staticRenderFns } from "./goodsGroupControl.vue?vue&type=template&id=3318a3cb&scoped=true&"
import script from "./goodsGroupControl.vue?vue&type=script&lang=js&"
export * from "./goodsGroupControl.vue?vue&type=script&lang=js&"
import style0 from "./goodsGroupControl.vue?vue&type=style&index=0&id=3318a3cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3318a3cb",
  null
  
)

export default component.exports